<template>
  <v-field :label='label' :error='errors.first(name)' :tooltip='tooltipMsg'>
    <input :disabled="$can.not('edit-exploitation')" v-bind='$attrs' :value='value' type='number' step='1' inputmode="numeric" @input='processInput' @change='processChange' lang="en" />
  </v-field>
</template>

<script>
import mixinTooltip from '@/mixins/tooltip'

export default {
  name: 'FieldInteger',

  inheritAttrs: false,
  inject: ['$validator'],
  mixins: [mixinTooltip],

  props: {
    value: Number,
    label: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: 'notDefined'
    },
    tooltip: {
      type: Boolean
    }
  },

  methods: {
    processInput (e) {
      let value = Number.parseInt(e.target.value)
      if (Number.isInteger(value)) {
        this.$emit('input', value)
      }
    },

    processChange (e) {
      let value = Number.parseInt(e.target.value)
      this.$emit('input', Number.isInteger(value) ? value : null)
    }
  }
}
</script>
